var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.dynamicComponentName == null),expression:"dynamicComponentName == null"}]},[(_vm.dynamicComponentName)?_c('span',[_c(_vm.dynamicComponentName,_vm._b({tag:"component"},'component',_vm.props,false))],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }